import src from "IMAGE";
export default { src, width: 1600, height: 415, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAR0lEQVR42g3IMQqAIBSAYS8VDVHpeypiYYK1NERT97/Bn+tnRhF0U8rZOO6P3F5ifUj5wgWPWeLOMAurJnysSCikbm5SrFh+x+gdewBUJ2MAAAAASUVORK5CYII="};
